import React, { useState } from 'react';
import {
  useCreateItemMutation,
  useDeleteItemMutation,
  useGetItemsQuery,
  useUpdateItemMutation,
} from '../slices/simpleApiSlice';
import { ArrowUpward, ArrowDownward, Delete, Add } from '@mui/icons-material';
// import ScreenContainer from './ScreenContainer';
import GridTableList from './GridTableList';
import AddDrawer from './AddDrawer';
// import { useEffect } from 'react';
// import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ButtonsBar from './ButtonsBar';

const RelatedList = ({ config, ownerId, readOnly, sx, item, backUrl }) => {
  // const theme = useTheme();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const filters = {};

  config.filter?.forEach((filter) => {
    let filterValue;

    if (
      filter.value &&
      typeof filter.value === 'object' &&
      filter.value.localField
    ) {
      // { localField: 'code' } → берём из inputs
      filterValue = item?.[filter.value.localField] || ownerId;
    } else {
      // Простое значение
      filterValue = filter.value;
    }

    if (filterValue !== undefined && filterValue !== null) {
      filters[filter.foreignField] = filterValue;
    }
  });

  // console.log('filters', filters);

  // 1. Определяем колонки ЛОКАЛЬНО
  const getDisplayColumns = (config) => {
    // Приоритет 1: columns из metadata
    if (config.columns?.length) {
      return config.columns;
    }

    // Приоритет 2: displayField
    if (config.displayField) {
      return [
        {
          field: config.displayField,
          label: config.label,
          width: 12,
        },
      ];
    }

    // Приоритет 3: foreignField → auto title
    const foreignField = config.filter?.[0]?.foreignField;
    if (foreignField) {
      return [
        {
          field: `${foreignField}.title`,
          label: config.label,
          width: 12,
        },
      ];
    }

    // 4. По умолчанию
    return [
      {
        field: 'title',
        label: 'Название',
        width: 12,
      },
    ];

    // return config.columns || [];
  };

  const queryUrl = `/api/directories/${config.slug}`;
  const directoryTag = `Directory-${config.slug.charAt(0).toUpperCase() + config.slug.slice(1)}`;

  const { data, refetch, isLoading, isFetching } = useGetItemsQuery({
    url: queryUrl,
    params: filters, // { type: "64fcfac...", visible: true }
    providesTags: [directoryTag],
  });

  // useEffect(() => {
  //   console.log('data', data);
  // }, [data]);

  const rows = data?.rows || [];
  const [selectedRowId, setSelectedRowId] = useState(null);
  // useEffect(() => {
  //   console.log('selectedRowId', selectedRowId);
  // }, [selectedRowId]);

  // ✅  Мутации основного списка
  const [createRelated] = useCreateItemMutation();
  const [updateRelated] = useUpdateItemMutation();
  const [deleteRelated] = useDeleteItemMutation();

  const handleSort = async (direction) => {
    // console.log('rows', rows);

    if (!selectedRowId) return;

    const currentIndex = rows.findIndex((r) => r._id === selectedRowId);
    // console.log('currentIndex', currentIndex);
    const targetIndex =
      direction === 'up' ? currentIndex - 1 : currentIndex + 1;
    // console.log('targetIndex', targetIndex);
    if (targetIndex < 0 || targetIndex >= rows.length) return;

    const targetRow = rows[targetIndex];
    // console.log('targetRow', targetRow);

    // console.log('targetRow.order', targetRow.order);
    // console.log('rows[currentIndex].order', rows[currentIndex].order);

    // Обмен order
    await Promise.all([
      updateRelated({
        url: `/api/directories/${config.slug}`,
        id: selectedRowId,
        order: targetRow.order,
      }),
      updateRelated({
        url: `/api/directories/${config.slug}`,
        id: targetRow._id,
        order: rows[currentIndex].order,
      }),
    ]);

    refetch();
  };

  const handleDelete = async () => {
    if (!selectedRowId) return;
    await deleteRelated({
      url: `/api/directories/${config.slug}/${selectedRowId}`,
      // id: selectedRowId,
    });
    refetch();
  };

  const handleAddOpen = () => {
    console.log('config', config);
    // {
    //     "method": "route",
    //     "slug": "tasks",
    //      state: [
    // 			    { field: 'isTemplate', value: true },
    // 			    { field: 'funnel', value: { localField: 'type' } },
    // 			    { field: 'stage', value: { localField: 'stage' } },
    // 		  ]
    // }
    if (config?.addOptions?.method === 'page') {
      const localUrl = `/directories/${config.slug}/new`;
      const state = config.addOptions.state?.reduce((acc, curr) => {
        if (curr.value?.localField) {
          acc[curr.field] = item?.[curr.value.localField] || ownerId;
        } else {
          acc[curr.field] = curr.value;
        }
        return acc;
      }, {});
      navigate(localUrl, { state: { backUrl, ...state } });
      return;
    }
    setOpenDrawer(true);
  };
  // const handleAddClose = () => setOpenDrawer(false);

  const handleAddSelected = async (selectedItem) => {
    // console.log('selectedItem', selectedItem);
    const payload = {
      url: `/api/directories/${config.slug}`, // typestages
      type: ownerId,
      stage: selectedItem._id || selectedItem,
      ownerId,
      itemId: selectedItem._id || selectedItem,
    };

    // console.log('payload', payload);

    // return;

    try {
      await createRelated(payload).unwrap();

      refetch();
    } catch (error) {
      console.error('Не удалось добавить:', error);
    }
  };

  const handleRowSelect = (rowData) => {
    // console.log('config', config);
    // console.log('handleRowSelect', rowData);

    if (config.actions?.includes('navigate')) {
      const localUrl = `/directories/${config.slug}/${rowData.id || rowData._id}`;
      // console.log('localUrl', localUrl);

      navigate(localUrl, { state: { backUrl } });
    } else {
      setSelectedRowId(rowData.id || rowData._id);
    }
  };

  const upButtons = [
    config.actions?.includes('sort') && {
      title: 'Вверх',
      onClick: () => {
        // console.log('Sorting up');
        handleSort('up');
      },
      type: 'icon',
      icon: <ArrowUpward />,
      disabled: !selectedRowId || rows[0]?.id === selectedRowId,
      xs: 2,
      position: 'right',
    },
    config.actions?.includes('sort') && {
      title: 'Вниз',
      onClick: () => {
        // console.log('Sorting down');
        handleSort('down');
      },
      type: 'icon',
      icon: <ArrowDownward />,
      disabled: !selectedRowId || rows[rows.length - 1]?.id === selectedRowId,
      xs: 2,
      position: 'right',
    },
    config.actions?.includes('add') && {
      type: 'icon',
      title: 'Добавить',
      onClick: handleAddOpen,
      icon: <Add />,
      xs: 2,
      position: 'left',
    },
    config.actions?.includes('delete') && {
      type: 'icon',
      title: 'Удалить',
      onClick: handleDelete,
      icon: <Delete />,
      color: 'error',
      disabled: !selectedRowId,
      xs: 2,
      position: 'left',
    },
  ].filter(Boolean);

  // console.log('RelatedList upButtons', upButtons);

  return (
    <>
      <ButtonsBar
        sx={{ m: 0, p: 0, ...sx }}
        buttons={readOnly ? [] : upButtons}
        isProgress={isFetching || isLoading}
      >
        <GridTableList
          sx={{ m: 0, p: 0 }}
          data={data}
          columns={getDisplayColumns(config)} // ← ЛОКАЛЬНО!
          onRowSelect={handleRowSelect}
          selectedId={selectedRowId}
          showActions={config.actions?.includes('edit')}
        />
      </ButtonsBar>
      {/* Drawer со списком для добавления */}
      {config.addOptions && (
        <AddDrawer
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          title={`Добавить этап в ${config.label}`}
          addSlug={config.addOptions.slug}
          filter={config.addOptions?.filter || []}
          existingIds={rows.map((r) => r._id)}
          onSelect={handleAddSelected}
        />
      )}
    </>
  );
};

export default RelatedList;
